export default function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}


//////////////////
// WEBPACK FOOTER
// /opt/mybespokeroom/shared/~/react-router-dom/~/@babel/runtime/helpers/esm/setPrototypeOf.js
// module id = 1466
// module chunks = 4 5 11 15